export default __webpack_public_path__ + "maps-guides-styles-expressions-zoom-high-960-0fb2371dc687cd9abdf672e63171eeae.png";